<template>
    <div class="TQ_padding_16px TQ_center">


        <tq-card padding="8px">

            <!-- search -->
            <div class="TQ_margin_8px">

                <!-- quest Type-->
                <tq-dropdown :style-select="true"
                             class="TQ_width_200px TQ_verticalAlignMiddle TQ_margin_4px">

                    <div slot="select" class="TQ_text_20px">
                        {{selectedQuestType}}
                    </div>

                    <div slot="options"
                         @click="selectedQuestType = questType"
                         v-for="questType in enum_questTypes">
                        {{questType}}
                    </div>

                </tq-dropdown>

                <!-- quest id -->
                <input class="TQ_input TQ_width_300px TQ_verticalAlignMiddle TQ_margin_4px TQ_text_20px"
                       placeholder="questId"
                       v-model="selectedQuestId"/>


                <tq-loader-button text="Get Discount Coupons"
                                  btn-class="TQ_btn TQ_bg_green"
                                  @clickBtn="m_getDiscountCoupons_f"
                                  :show-loader="showBtnLoader_b"/>
            </div>

            <!-- table-->
            <div class="TQ_bg_gray4 TQ_padding_8px">
                <tq-table
                        class="TQ_bg_white TQ_padding_8px "
                        :rows="discountCoupons_ac"
                        :system-lang-code="store_system_langCode_ve.val"
                        :display-search="true"
                        p_td-classes_s="TQ_padding_8px"
                        :columns="[
                       {label : 'Coupon Id',        field : (discountCoupons_c) => {return discountCoupons_c.qdc_couponId_uid}},
                       {label : 'Discount (%)',     field : (discountCoupons_c) => {return discountCoupons_c.qdc_discountPercentage_n}},
                       {label : 'Discount Code',    field : (discountCoupons_c) => {return discountCoupons_c.qdc_couponCode_s}},
                       {label : 'Active',           field : (discountCoupons_c) => {return discountCoupons_c.qdc_active_b}},
                       {label : 'History',          field : (discountCoupons_c) => {return Object.values(discountCoupons_c.qdc_history_byTimeStamp_c)}},
                    ]"
                />
            </div>





        </tq-card>

        <div class="TQ_padding_8px"> </div>

        <tq-card padding="16px">

            <div class="TQ_text_24px TQ_margin_bottom_8px">
                Create new Discount Coupon
            </div>

            <div>

                <!-- quest Type-->
                <tq-dropdown :style-select="true"
                             class="TQ_width_200px TQ_verticalAlignMiddle TQ_margin_4px TQ_verticalAlignMiddle">

                    <div slot="select">
                        {{newQuestCoupon_o.questType_e}}
                    </div>

                    <div slot="options"
                         @click="newQuestCoupon_o.questType_e = questType"
                         v-for="questType in enum_questTypes">
                        {{questType}}
                    </div>

                </tq-dropdown>

                <!-- quest id-->
                <input placeholder="questId" type="text" class="TQ_padding_4px TQ_margin_4px TQ_width_200px TQ_verticalAlignMiddle" v-model="newQuestCoupon_o.questId_uid"/>

                <!-- discount percentage -->
                <input placeholder="1-100" type="number" min="0" max="100" class="TQ_padding_4px TQ_margin_4px TQ_width_100px TQ_verticalAlignMiddle" v-model.number="newQuestCoupon_o.discountPercentage_n"/>

                <!-- coupon code -->
                <input placeholder="couponCode" type="text" class="TQ_padding_4px TQ_margin_4px TQ_width_200px TQ_verticalAlignMiddle" v-model="newQuestCoupon_o.couponCode_s"/>

            </div>

            <div class="TQ_inline TQ_bg_green TQ_padding_8px TQ_borderRadius TQ_margin_top_8px TQ_clickable" @click="m_createNewQuestDiscountCoupon_f" v-if="co_showCreateNewCoupon_f">
                Create
            </div>

        </tq-card>

    </div>
</template>

<script>
    import TqTable from "../../components/basic2/TqTable";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary"
    import {enum_questTypes} from "../../../functions/src/shareCode/Share_S_Enum"
    import {store_getStateValue_vo, store_var} from "../../store";
    import TqLoaderButton from "../../components/basic2/TqLoaderButton";
    import TqDropdown from "../../components/basic/TqDropdown";
    import TqCard from "../../components/basic/TqCard";
    import {
        server_admin_createNewQuestDiscountCoupons_f,
        server_discountCoupons_getAll_f,
    } from "../../scripts/Server/S_ServerPre";
    import TqToggleSwitch from "../../components/basic/TqToggleSwitch";
    import {notification_notify} from "../../scripts/S_Notification";
    export default {
        name: "v_Admin_DiscountCoupons",
        components: {TqToggleSwitch, TqCard, TqDropdown, TqLoaderButton, TqTable},
        data(){
            return {
                discountCoupons_ac : [],
                selectedQuestType : enum_questTypes.CARDS,
                selectedQuestId : "",
                showBtnLoader_b : false,

                newQuestCoupon_o : {
                    questType_e             : enum_questTypes.CARDS,
                    questId_uid             : null,
                    discountPercentage_n    : null,
                    couponCode_s            : null,
                },

                // store
                store_system_langCode_ve : store_getStateValue_vo(store_var.system_langCode),

                // import
                ass_strings : ass_strings,
                enum_questTypes : enum_questTypes,

            }
        },
        computed:{
            co_showCreateNewCoupon_f(){

                for(let key in this.newQuestCoupon_o){

                    if(this.newQuestCoupon_o[key] == null){
                        return false
                    }

                }

                return true
            }
        },
        methods:{
            m_getDiscountCoupons_f(){
                this.showBtnLoader_b = true
                server_discountCoupons_getAll_f(this.selectedQuestType, this.selectedQuestId, (discountCoupon_byCouponId_c) => {
                    this.showBtnLoader_b = false
                    this.discountCoupons_ac = Object.values(discountCoupon_byCouponId_c)
                })
            },
            m_createNewQuestDiscountCoupon_f(){


                server_admin_createNewQuestDiscountCoupons_f(this.newQuestCoupon_o, () =>{})


            }
        }
    }
</script>

<style scoped>

</style>